import { useState } from "react";
import { Grid, Button, CircularProgress } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import axios from "../../customAxios.js";
import { dateToDatabase, checkDownloadStatus } from "../../utils/functions.js";
import useSocket from "../../hooks/useSocket.jsx";

const DownloadExcel = ({
  user,
  startDate,
  endDate,
  companyFilter,
  search,
  statusFilter,
  deliveriesCount,
  setErrorOnRetrieveData,
  handleSnack,
}) => {
  const [downloadExcelState, setDownloadExcelState] = useState(null);

  const isLoading = ["started", "processing"].includes(
    downloadExcelState?.status
  );
  const isDisabled = isLoading || deliveriesCount === 0;

  useSocket({
    userId: user.id,
    userRole: user?.user_type?.[0] || "unknown_role",
    eventPrefix: "download",
    onMessage: (data) => {
      console.log(`📥 RECEIVED NOTIFICATION: ${JSON.stringify(data)}`);
      setDownloadExcelState(data);
      if (handleSnack) handleSnack(true, checkDownloadStatus(data.status));
    },
  });

  const fetchExcel = async () => {
    setDownloadExcelState({ status: "started" });

    const payload = {
      start_date: dateToDatabase(startDate),
      end_date: dateToDatabase(endDate),
      company: companyFilter,
      search: search,
      delivery_status: statusFilter,
    };

    try {
      const response = await axios.post("api/download-delivery-resume/", payload);
      console.table(response);
      if (setErrorOnRetrieveData) setErrorOnRetrieveData();
    } catch (error) {
      console.error(`[EXCEPTION] ${error}`);
      if (setErrorOnRetrieveData)
        setErrorOnRetrieveData("Ocurrió un error al obtener el excel");
    }
  };

  return (
    <Grid item xs={12} md={2} xl={2}  sx={{mb: 1}}>

      <Button variant="outlined" onClick={fetchExcel} disabled={isDisabled}>
        {isLoading ? (
          <CircularProgress className="loading-btn" />
        ) : (
          <>
            <DownloadIcon fontSize="small" />
            {deliveriesCount ? "Exportar deliveries" : "Sin deliveries"}
          </>
        )}
      </Button>
    </Grid>
  );
};

export default DownloadExcel;
